<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Solicitações de cartões Bankei</span>
    </div>
    <div class="component-box container-fluid">
        <div class="container-fluid pt-4">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <ul class="options-cadastro pl-0 float-left">
                        <li>
                            <div (click)="exportExcel()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar Excel</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="exportPdf()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar PDF</span>
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-md-6 text-right">
                    <ul class="options-cadastro">
                        <li>
                            <div *ngIf="filtroOn" (click)="deleteFilter()" class="list-select ml-2
                                my-1">
                                <button class="list-select-delete" type="button">
                                    Apagar filtro
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="showFilter(modalfiltro)" class="list-select ml-2 my-1">
                                <button class="list-select"  type="button">
                                    <span><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div class="list-filter-show-item ml-2 my-1">
                                Mostrar:
                                <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                    <option _ selected="" value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <span  class="d-flex justify-content-end clean-modal-text my-2" style="font-size:small;">Data da consulta: {{ queryDate | date: "dd/MM/yyyy HH:mm:ss" }}</span>
            
            <div class="row">
                <div class="col-12">
                    <ul class="options-cadastro pl-0 float-left">
                        <li class="mr-3"><b>Data inicio: </b>{{ filtro.dateStart | date: "dd/MM/yyyy"}}</li>
                        <li class="mr-3"><b>Data fim: </b>{{ filtro.dateEnd | date: "dd/MM/yyyy"}}</li>
                        <li class="mr-3" *ngIf="filtroOn && filtro.status"><b>Situação: </b>{{ getStatus(filtro.status) }}</li>
                        
                    </ul>
                </div>
            </div>  

            <div class="table-overflow">
                <div class="table-responsive visible-table">
                    <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <th>Número do Pedido</th>
                            <th>Quantidade</th>
                            <th>Data do Pedido</th>
                            <th>Data de Entrega</th>
                            <th>Situação do Pedido</th>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor=" let item of cardSolicitation | paginate : { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalItems, id: 'cardStatus' }">
                                <td>{{item.solicitationId}}</td>
                                <td>{{item.quantity}}</td>
                                <td>{{item.solicitationDate | date: 'dd/MM/yyyy HH:mm'}}</td>                                
                                <td *ngIf="item.deliveryDate != null">{{item.deliveryDate | date: 'dd/MM/yyyy HH:mm'}}</td>
                                <td *ngIf="item.deliveryDate == null">-</td>
                                <td>{{item.statusDescription}}</td>
                                <!-- <td>
                                    <div ngbDropdown class="d-inline-block menu-option custom-context-menu-container" placement="left">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle><img
                                                src="assets/icons/menu.png" /></button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">
                                                <div ngbDropdownItem (click)="details(item)">
                                                    <img src="assets/icons/pencil-purple.png" class="mr-2" />Detalhes do pedido
                                                </div>
                                                <div *ngIf="item.statusId === 1" ngbDropdownItem (click)="showCancel(cancelmodal,item)">
                                                    <img src="assets/icons/garbage-purple.png" class="mr-2" />Cancelar pedido
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </td>                   -->
                            </tr>
                        </tbody>
                    </table>
                    
                    <div *ngIf="!cardSolicitation || cardSolicitation == [] || cardSolicitation.length == 0" class="text-center">
                            Nenhum registro carregado. Aplique o filtro para retornar a lista com registros
                    </div>

                    <div class="page-custom mt-2">
                        <pagination-controls id="cardStatus" (pageChange)="carregarRelatorio($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #modalfiltro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <input id="startDate" matInput [matDatepicker]="startDate" placeholder="Data Início" [value]="filtro.dateStart"  (dateChange)="setPeriod(true,$event.value)"/>
                    <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                    <mat-datepicker #startDate></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <input id="endDate" matInput [min]="filtro.dateStart" [max]="dataMaxima" [matDatepicker]="endDate" placeholder="Data Fim" [value]="filtro.dateEnd"  (dateChange)="setPeriod(false,$event.value)"/>
                    <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                    <mat-datepicker #endDate></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Situação</mat-label>
                    <mat-select [formControl]="statusCtrl" placeholder="Selecione...">
                        <mat-option>Nenhum</mat-option>
                        <mat-option value="1">Em análise</mat-option>
                        <mat-option value="2">Em Processamento</mat-option>
                        <mat-option value="3">Concluído</mat-option>
                        <mat-option value="4">Cancelado</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>